<template>

  <div class="sbd-upload-img" v-bind:class="{isAuto:isAuto}">
      <p class="def-icon" v-show="!isAuto">
        <img :src="defImg" width="50%" />
        <i>请上传格式为jpg、jpeg、png类型的照片</i>
      </p>
      <input type="file" class="upload-file" @change="getFile" ref="file" id="file" accept=".png, .jpg, .jpeg"/>
      <img :src="imgUrl" class="upload-avater-s" width="100%;"/>
  </div>

</template>

<script>
    export default {
        name: "UploadImg",
        data () {
          return {
            imgUrl:"",
            isAuto: false,
          }
        },
        props:{
          defImg:{
            type:String
          },
          maxSize:{
            type:String,
            default:'2'
          },
        },
        methods:{
          getFile(e){
            let _this = this;
            let files = e.target.files[0];
            console.log(files.type)
            let type = files.type.split('/');

            if(files.size / 1024 /1024 > Number(this.maxSize)){
              this.$emit('sendWarning','1');
              return false;
            }
            if(type[1] != 'png' && type[1] != 'jpg' && type[1] != 'jpeg'){
              this.$emit('sendWarning','2');
              return false;
            }

            let reader = new FileReader();
            reader.readAsDataURL(files);

            reader.onload = function () {
              var _reader = this;
              var image = new Image();
              image.src = this.result;
              image.onload=function() {
                _this.isAuto = true;
                _this.imgUrl = _reader.result;
                _this.$emit('sendImgFile',{files:files});
              }
            }

          }
        },
        mounted(){
          if(window.File && window.FileList && window.FileReader && window.Blob) {

          } else {
            this.$emit('sendWarning','0');
          }

        },
        created(){

        }
    }
</script>

<style scoped>

.sbd-upload-img{ width: 150px;height:150px;border:1px solid #b8b9bd;border-radius: 5px;position: relative;z-index: 9; }
.sbd-upload-img.isAuto{ height: auto; }
.sbd-upload-img .def-icon{ width: 98%;margin-left: 1%;top:8%;z-index: 6;position: absolute; }
.sbd-upload-img .def-icon i{ font-size: 12px;color:#999;float: left; }
.upload-file{ position: absolute;width: 100%;height:100%;opacity: 0;z-index: 8;left:0;top:0; }
.upload-avater-s{ width: 100%;z-index: 7;display: block; }
</style>



// WEBPACK FOOTER //
// src/model/uploadImg/uploadImg.vue